import axios from "axios";

/**
 * Options for uploading to Cloudinary.
 */
interface CloudinaryUploadOptions {
    /** File to be uploaded (image, pdf, etc.) */
    file: File;
    /** Optional folder path (e.g., "cms/products/user123") */
    folder?: string;
    /** Optional custom upload preset (defaults to .env config) */
    uploadPreset?: string;
}

/**
 * Uploads a file to Cloudinary using the unsigned upload API.
 *
 * @param options - Upload options
 * @returns Cloudinary response data on success, or null if validation fails.
 */
export const uploadFileToCloudinary = async ({
    file,
    folder = "upload",
    uploadPreset = process.env.REACT_APP_UPLOAD_PRESET,
}: CloudinaryUploadOptions): Promise<any | null> => {
    const CLOUD_NAME = process.env.REACT_APP_CLOUD_NAME;
    const API_URL = process.env.REACT_APP_API_CLOUDNIRY_URL;

    if (!CLOUD_NAME || !API_URL || !uploadPreset) {
        throw new Error("Missing Cloudinary configuration.");
    }

    const CLOUDINARY_URL = `${API_URL}/${CLOUD_NAME}/upload`;

    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", uploadPreset);
    if (folder) {
        formData.append("folder", folder);
    }

    try {
        const response = await axios.post(CLOUDINARY_URL, formData);
        return response.data;
    } catch (error) {
        throw error; // Caller will handle error UI
    }
};
